"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _glamor = require("glamor");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../constants");

var _Toast = _interopRequireDefault(require("./Toast"));

var wrapperClass = (0, _glamor.css)({
  maxWidth: 560,
  margin: '0 auto',
  top: 0,
  left: 0,
  right: 0,
  position: 'fixed',
  zIndex: _constants.StackingOrder.TOASTER,
  pointerEvents: 'none'
});

var hasCustomId = function hasCustomId(settings) {
  return Object.hasOwnProperty.call(settings, 'id');
};

var ToastManager =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ToastManager, _React$PureComponent);

  function ToastManager(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, ToastManager);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ToastManager).call(this, props, context));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getToasts", function () {
      return _this.state.toasts;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeAll", function () {
      _this.getToasts().forEach(function (toast) {
        return toast.close();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "notify", function (title, settings) {
      // If there's a custom toast ID passed, close existing toasts with the same custom ID
      if (hasCustomId(settings)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this.state.toasts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var toast = _step.value;

            // Since unique ID is still appended to a custom ID, skip the unique ID and check only prefix
            if (String(toast.id).startsWith(settings.id)) {
              _this.closeToast(toast.id);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      var instance = _this.createToastInstance(title, settings);

      _this.setState(function (previousState) {
        return {
          toasts: [instance].concat((0, _toConsumableArray2.default)(previousState.toasts))
        };
      });

      return instance;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createToastInstance", function (title, settings) {
      var uniqueId = ++ToastManager.idCounter;
      var id = hasCustomId(settings) ? "".concat(settings.id, "-").concat(uniqueId) : uniqueId;
      return {
        id: id,
        title: title,
        description: settings.description,
        hasCloseButton: settings.hasCloseButton || true,
        duration: settings.duration || 5,
        close: function close() {
          return _this.closeToast(id);
        },
        intent: settings.intent
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeToast", function (id) {
      _this.setState(function (previousState) {
        return {
          toasts: previousState.toasts.map(function (toast) {
            if (toast.id === id) {
              return (0, _objectSpread2.default)({}, toast, {
                isShown: false
              });
            }

            return toast;
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeToast", function (id) {
      _this.setState(function (previousState) {
        return {
          toasts: previousState.toasts.filter(function (toast) {
            return toast.id !== id;
          })
        };
      });
    });
    props.bindNotify(_this.notify);
    props.bindGetToasts(_this.getToasts);
    props.bindCloseAll(_this.closeAll);
    _this.state = {
      toasts: []
    };
    return _this;
  }

  (0, _createClass2.default)(ToastManager, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("span", {
        className: wrapperClass
      }, this.state.toasts.map(function (_ref) {
        var id = _ref.id,
            description = _ref.description,
            props = (0, _objectWithoutProperties2.default)(_ref, ["id", "description"]);
        return _react.default.createElement(_Toast.default, (0, _extends2.default)({
          key: id,
          onRemove: function onRemove() {
            return _this2.removeToast(id);
          }
        }, props), description);
      }));
    }
  }]);
  return ToastManager;
}(_react.default.PureComponent);

exports.default = ToastManager;
ToastManager.displayName = "ToastManager";
(0, _defineProperty2.default)(ToastManager, "propTypes", {
  /**
   * Function called with the `this.notify` function.
   */
  bindNotify: _propTypes.default.func.isRequired,

  /**
   * Function called with the `this.getToasts` function.
   */
  bindGetToasts: _propTypes.default.func.isRequired,

  /**
   * Function called with the `this.closeAll` function.
   */
  bindCloseAll: _propTypes.default.func.isRequired
});
(0, _defineProperty2.default)(ToastManager, "idCounter", 0);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/toaster/src/ToastManager.js
// module id = 263
// module chunks = 0